import React from 'react';



export default function Footer() {
  return (
            <footer className='footer'>
                <div className='LogoIcon'>
                </div>

                <div className="about">
                    <ul>
                        <li>A propos</li>
                        <li>société</li>
                        <li>Politique de confidentialité </li>
                        <li>Politique de cookies </li>
                        <li>Technologies</li>
                    </ul>
                </div>

                <div className="customer">
                    <ul>
                        <li>Service Clients</li>
                        <li>Contactez-nous</li>
                        <li>Conditions de vente</li>
                        <li>FAQ</li>
                        <li>Retour</li>
                        <li>Paiement</li>
                        <li>Expédition</li>
                    </ul>
                </div>

                <div className="link">                   
                    <ul>
                        <li>Liens rapides</li>
                        <li>Actualités et événements</li>
                        <li>Yon&Es club</li>
                        <li>Suggestions & prix</li>
                        <li>Partagez vos photos</li>
                        <li>D2D</li>
                    </ul>
                </div>

                <div className='mssg'>
                    <div className='messageIcon'>
                        BUTTUS_NEW MSG
                    </div>
                    <div className='locationIcon'>
                       magasin le plus proche
                    </div>
                    <div className='English'>Englais</div>
                    <div>
                        <i class="fab fa-instagram fa-2x"></i>
                        <i class="fab fa-facebook-f fa-2x"></i>
                        <i class="fab fa-twitter fa-2x"></i>
                        <i class="fab fa-youtube fa-2x"></i>
                    </div>                   
                </div>
            </footer>
      );
}


